<template>
  <iframe
    :srcdoc="templateEmail"
    title="preview-email-details"
    class="iframe-email"
    height="480px"
    width="800px"
    ref="iframe"
    @load="scaleIframeContent"
  ></iframe>
</template>

<script lang="ts" setup>
import { ref, computed } from "vue";

const props = defineProps<{
  dataSource: DataSourceStrategy;
}>();

const iframe = ref();

const templateEmail = computed(() => {
  console.log(props.dataSource.message_text, "props.dataSource Aqui");
  return props.dataSource.message_text;
});

const scaleIframeContent = () => {
  console.log("iframe.value.contentWindow", iframe.value.contentWindow);
  if (props.dataSource.template_email) {
    const scale = 0.7; // Escala el contenido al 70% de su tamaño original
    iframe.value.contentWindow.document.body.style.zoom = scale;

    const iframeDoc = iframe.value.contentDocument || iframe.value.contentWindow.document;
    const style = iframeDoc.createElement("style");
    style.textContent = `
        ::-webkit-scrollbar {
          width: 10px;
          margin-right: 10px;
        }
        ::-webkit-scrollbar-thumb {
          background-color: #D9D9D9;
          border-radius: 5px;
        }
        ::-webkit-scrollbar-thumb:hover {
          background-color: #D9D9D9;
        }
      `;
    iframeDoc.head.appendChild(style);
  }
};
</script>

<style lang="sass" scoped>
.section
  &__content-filters
    margin-top: 24px
    background: $base-ninja-100
    border-radius: 4px
    padding: 16px
  &__content-text, &__content-label
    color: $text-secondary
  &__content-list
    padding-left: 24px
  &__details
    margin-right: 40px
    width: 180px
  &__info
    width: 300px
    margin-right: 20px
  &__preview
    width: 224px
.iframe-email
  border-radius: 8px
  border: 1px solid #00000026
</style>
